
export function loadTerrain(map) {
    map.addSource('terrainSource', {
        type: 'raster-dem',
        url: 'map/terrain-tiles/tiles.json',
        tileSize: 256,
    });

  map.setTerrain({source: 'terrainSource', exaggeration: 1,});

  console.log('[Map] 3D terrain loaded');
}
